import Notifier from 'common/helpers/Notifier';
import _ from 'lodash';
import { CLOSE_SERVICE_CASE, ADD_CONTACT_PROVIDED_SERVICE } from 'actions';
import { coreApi } from 'src/api/config';
import moment from 'moment';
import createNote from './createNote';

export default function closeServiceCase(groupId, contactId, caseObj, closing) {
  function canSentClosedDate(isOON, isOpenedDatePresent) {
    if (isOON) {
       return true;
    }
      return isOpenedDatePresent;
  }

  return async (dispatch, getState) => {
    try {
      await dispatch(createNote({
        interaction: {
          note: closing.note,
          occurred_on: closing.exited_at,
          category: 'general',
        },
        subjectType: 'case',
        subject: caseObj.id,
        opts: { sendSuccessNotification: false },
        context: 'closed',
      }));

      const {
        outcome_id,
        exited_at,
        opened_date,
      } = closing;
      const isOON = _.get(caseObj, 'state') === 'off_platform';
      const isOpenedDatePresent = caseObj.opened_date;
      const sendClosedDate = canSentClosedDate(isOON, isOpenedDatePresent);
      const openedDate = opened_date ? moment.unix(opened_date).utc().format('YYYY-MM-DD') : false;
      const currentProviderId = _.get(getState(), 'globalState.currentEmployee.provider.id', undefined);
      const isInternalCase = _.isEqual(currentProviderId, caseObj.provider.id);
      const canEditOpenedDate = isOON || isInternalCase;

      const updateData = {
        outcome: outcome_id,
        ...(sendClosedDate && {
          closed_date: moment.unix(exited_at).utc().format('YYYY-MM-DD'),
        }),
        ...(openedDate && canEditOpenedDate && sendClosedDate && {
          opened_date: openedDate,
        }),
      };
      const caseResponse = await coreApi.updateRecord('case', caseObj.id, updateData);

      dispatch({
        type: CLOSE_SERVICE_CASE,
        payload: caseResponse,
        contactId,
      });
      Notifier.dispatch(caseResponse.status, 'Case Successfully closed');

      dispatch({
        type: ADD_CONTACT_PROVIDED_SERVICE,
      });

      return caseResponse;
    } catch (error) {
      Notifier.handleErrors(error);
      return error;
    }
  };
}
